import React from 'react';

// import { Container } from './styles';
import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData'

function Demography() {
    const onClickFilter = () => {

    }
    return (
        <div>
            <FilterData onClickFilter={onClickFilter} />
        </div>
    );
}

export default Demography;